import React from 'react';
import { selectResources, selectFlow, selectShowInsurances, selectMinimal } from '../store/selectors';
import { connect } from 'react-redux';
import Checkbox from '../components/checkbox';
import { addInsurance, removeInsurance, setAdditionalInfoAction, setShowInsurancesAction } from '../store/actions';
import { GetQuoteInfo } from '../components/get-quote-info';
import { insuranceKeys } from '../store/insurance-keys';
import { InsuranceGuideInfo } from '../components/insurance-guide-info';
import { AnimateHeight } from 'migration-flos-react';

const Insurances = ({
    resources,
    toggleInsurance,
    setAdditionalInfo,
    flow,
    setShowInsurances,
    showInsurances,
    minimal
}) => {
    const {
        section1: { insurances, title, description1, description2, insurance, other },
        fsguide
    } = resources;
    const { car, indbo } = insurance.dependent;
    const isInsuranceGuide = flow === appFlow.INSURANCE_GUIDE;
    const flexDisplay = {
        display: 'flex',
        flexWrap: 'wrap'
    };
    const description1Alt = resources.section1.minimal.description1;

    const checkboxes = Object.values(insurances).map((insuranceObject, index) => {
        return (
            <div key={index} className="col-lg-7 col-md-12 col-sm-12 col-xs-12 checkbox-wrapper row">
                <fieldset className="checkBoxClasses">
                    <legend className="tds-CheckboxGroup-title tds-CheckboxGroup-title--bold tds-CheckboxGroup-title--larger">
                        {insuranceObject['title']}
                    </legend>
                    <div className="row u-Space-down" style={flexDisplay}>
                        {Object.keys(insuranceObject)
                            .filter((key) => key !== 'title')
                            .sort((a, b) => {
                                const aIndex = +insuranceObject[a].split('.')[0];
                                const bIndex = +insuranceObject[b].split('.')[0];
                                if (aIndex > bIndex) {
                                    return 1;
                                }
                                if (aIndex < bIndex) {
                                    return -1;
                                }
                                return 0;
                            })
                            .map((key) => {
                                const note = key === 'ROADSIDE_ASSIST' ? car : key === 'TRAVEL' ? indbo : null;
                                return (
                                    <Checkbox
                                        onToggle={toggleInsurance(insuranceKeys[key])}
                                        label={insuranceObject[key] && insuranceObject[key].split('.')[1]}
                                        value={insuranceKeys[key]}
                                        key={key}
                                        index={key}
                                        note={note}
                                    />
                                );
                            })}
                    </div>
                </fieldset>
            </div>
        );
    });

    const InfoTitle = isInsuranceGuide ? (
        <InsuranceGuideInfo fsguide={fsguide} setShowInsurances={setShowInsurances} showInsurances={showInsurances} />
    ) : (
        <GetQuoteInfo
            title={title}
            description1={minimal ? description1Alt : description1}
            description2={description2}
            minimal={minimal}
        />
    );

    return (
        <div className="container u-Space-down">
            {InfoTitle}
            {!minimal && (
                <AnimateHeight expanded={isInsuranceGuide && !showInsurances ? showInsurances : true}>
                    <form id="Get-quote-insurance-form">
                        <div className="u-Space-up--lg">{checkboxes}</div>
                        <div className="u-Space-up col-lg-7 col-md-12 col-sm-12 col-xs-12 row">
                            <div className="form-group">
                                <label htmlFor="normal">{other.insurance.title}</label>
                                <textarea
                                    className="form-control"
                                    id="additionalInfo"
                                    rows="5"
                                    cols="40"
                                    title="Additional info"
                                    onChange={(event) => setAdditionalInfo(event.target.value)}
                                />
                            </div>
                        </div>
                    </form>
                </AnimateHeight>
            )}
        </div>
    );
};

const appFlow = {
    INSURANCE_GUIDE: 'INSURANCE_GUIDE',
    GET_QUOTE: 'GET_QUOTE'
};

const mapStates = (state) => ({
    resources: selectResources(state),
    flow: selectFlow(state),
    showInsurances: selectShowInsurances(state),
    minimal: selectMinimal(state)
});

const mapDispatch = (dispatch) => ({
    toggleInsurance: (name) => (checked) => dispatch(checked ? addInsurance(name) : removeInsurance(name)),
    setAdditionalInfo: (info) => dispatch(setAdditionalInfoAction(info)),
    setShowInsurances: (shouldShowInsurance) => {
        dispatch(setShowInsurancesAction(shouldShowInsurance));
    }
});

export default connect(mapStates, mapDispatch)(Insurances);
